/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Grid, Paper, useMediaQuery } from '@material-ui/core';
// import {
//   appointmentsMainFormatter,
//   expensesMainFormatter,
//   kaidsMainFormatter,
//   salesMainFormatter,
//   purchaseMainFormatter,
//   taskDataView,
//   daysdataMainFormatter,
//   resourseDataView,
//   employeeDataView,
//   customerDataView,
//   incomeMainFormatter,
//   employeeMainFormatter,
//   raseedMainFormatter,
// } from './colorFormat';
import getGereralCalculation from '../graphql/query/getGereralCalculation';
// import ReminderBox from './ReminderBox';
import { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import RefetchBox from './RefetchBox';
// import { ImageView } from '../components/viewer';
import useCompany from '../hooks/useCompany';
import { renderCell } from '../Sections/generator/page/renders';

export default function MainCustomer({
  isRTL,
  words,
  theme,
  name,
  id,
  value: row,
  width,
  height,
  start,
  end,
  setCalcs,
  isSubcontract,
}: any) {
  const [data, setData] = useState<any>(null);

  const isCust = name === 'customerId';
  const isSupp = name === 'supplierId';
  const isCont = name === 'contractId';
  const isProj = name === 'projectId';
  const isReso = name === 'resourseId';
  const isEmpl = name === 'employeeId';
  const isDepart = name === 'departmentId';
  const { company } = useCompany();
  const stringTemplate = isCust
    ? company?.custemp
    : isSupp
    ? company?.suptemp
    : isCont
    ? company?.tsktemp
    : isProj
    ? company?.tsktemp
    : isReso
    ? company?.restemp
    : isEmpl
    ? company?.emptemp
    : isDepart
    ? company?.deptemp
    : null;

  const template = stringTemplate ? JSON.parse(stringTemplate) : [];

  const [loadCalcss, calcsData]: any = useLazyQuery(getGereralCalculation, {
    fetchPolicy: 'cache-and-network',
  });
  const isMobile = useMediaQuery('(max-width:600px)');

  useEffect(() => {
    const variables = {
      [name]: id,
      start: start ? new Date(start).setHours(0, 0, 0, 0) : undefined,
      end: end ? new Date(end).setHours(23, 59, 59, 999) : undefined,
    };
    loadCalcss({
      variables,
    });
  }, [id, start, end]);

  useEffect(() => {
    const res = calcsData?.data?.getGereralCalculation?.data;
    if (res) {
      const data = JSON.parse(res);
      if (isCont) {
        data.coAmount = row.amount;
      }
      if (setCalcs) {
        setCalcs(data);
      }
      setData(data);
    }
  }, [calcsData, start, end]);
  const refresh = () => calcsData?.refetch();
  const loading = calcsData.loading;
  return (
    <Box
      style={{
        height: height - 250,
        width: width - 300,
        margin: 10,
      }}
    >
      <Box
        style={{
          position: 'absolute',
          width: 50,
          height: 50,
          left: isRTL ? 220 : undefined,
          right: isRTL ? undefined : 220,
          zIndex: 111,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          top: 55,
        }}
      >
        <RefetchBox
          isRTL={isRTL}
          theme={theme}
          refresh={refresh}
          loading={loading}
        ></RefetchBox>
      </Box>
      <Paper
        style={{
          height: height - 260,
          width: width - 320,
          overflow: 'auto',
          padding: 10,
          backgroundColor: '#f5f5f5',
        }}
        elevation={0}
      >
        {template?.map((listitem: any) => {
          return (
            <Grid container spacing={2}>
              {listitem?.map((item: any) => {
                const { size, type } = item;
                const args = {
                  ...item,
                  isRTL,
                  theme,
                  words,
                  company,
                  name,
                  id,
                  row: { ...row, ...data },
                };
                if (
                  (type === 'SalesDataBx' ||
                    type === 'IncomeDataBx' ||
                    type === 'TaskDaysBx' ||
                    type === 'RaseedDataBx') &&
                  isSubcontract
                )
                  return <></>;
                return (
                  <Grid item xs={12} md={size} style={{ marginBottom: 10 }}>
                    {renderCell(type, args, isMobile)}
                  </Grid>
                );
              })}
            </Grid>
          );
        })}
      </Paper>
    </Box>
  );
}
